import { inject, Injectable } from "@angular/core";
import { BridgeDefaultActionService, BridgeService } from "@vega/bridge";
import { IToolBarActions } from "@vega/ui-toolbox/action-bar";
import { Observable, from } from "rxjs";
import { map } from "rxjs/operators";

@Injectable()
export class ToolBarBridgeActions implements IToolBarActions {
    private _bridgeDefaultActionService = inject(BridgeDefaultActionService);
    private _bridgeService = inject(BridgeService);
    public isFavorite$ = from(this._bridgeService.getBootstrapDataAsync()).pipe(map((data) => data?.isFavorite));
    public showToolBar$ = from(this._bridgeService.getBootstrapDataAsync()).pipe(
        map((data) => {
            if (!data) {
                return false;
            }
            return data.showTitleBarCommands;
        })
    );

    public close(): Observable<boolean> {
        return this._bridgeDefaultActionService.closeForm();
    }
    public minimize(): Observable<boolean> {
        return this._bridgeDefaultActionService.minimizeForm();
    }
    public toggleDocked(): Observable<boolean> {
        return this._bridgeDefaultActionService.toggleDocked();
    }
    public toggleFavorite(): Observable<boolean> {
        return this._bridgeDefaultActionService.toggleFavorite();
    }
}
